module.exports = __webpack_public_path__ + "img/blik.d4b0e7d1.svg";